import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=127c9a24&scoped=true"
import script from "./breadcrumb.vue?vue&type=script&lang=js"
export * from "./breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=127c9a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c9a24",
  null
  
)

export default component.exports